<template>
	<i :class="className" class="text-5xl lg:text-6xl hover:opacity-75 text-gray-900 text-5xl"></i>
</template>

<script>
	export default {
		props: ['name'],
		data() {
			return {
				noWordmark: ['php', 'sass', 'gulp', 'javascript']
			}
		},
		computed: {
			className() {
				let className =  `devicon-${this.name}-plain`

				if (this.noWordmark.includes(this.name)) {
					return className;
				}

				return className + '-wordmark';
			}
		}
	}
</script>

<style src="../assets/css/devicon.css"></style>
